<template>
  <div class="container">
    <div class="header__grid">
      <div class="header__col header__col--logo">
        <router-link v-bind:to="basis.url" class="header__col header__col--logo">
          <img :src="basis.logo" class="header__logo-img" />
        </router-link>
      </div>

      <menue :mainmenue="context.mainmenue" />

      <div class="header__col header__col--buttons">
        <ul class="header__buttons-list">
          <li class="header__buttons-list-item" v-if="basis.linkheaderbutton1?.url">
            <a
              :href="basis.linkheaderbutton1.url"
              :target="basis.linkheaderbutton1.target"
              class="button header__button header__button--login"
            >
              {{ basis.linkheaderbutton1.text }}
            </a>
          </li>
          <li class="header__buttons-list-item" v-if="basis.linkheaderbutton2?.url">
            <a
              :href="basis.linkheaderbutton2.url"
              :target="basis.linkheaderbutton2.target"
              class="button header__button header__button--login"
            >
              {{ basis.linkheaderbutton2.text }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Menue from './MainMenue.vue';

export default {
  name: 'MicrositeHeader',
  data() {
    return {
      basis: this.context.basis,
    };
  },
  props: {
    context: {
      type: Object,
    },
  },
  components: {
    Menue,
  },
};
</script>
